import React, { useState } from "react";
import { Container, PageTitle } from "../../components/refactor/components";
import Button from "../../components/Button";
import { PlusIcon, SearchIcon } from "@heroicons/react/outline";
import { InertiaLink } from "@inertiajs/inertia-react";
import { DataGrid, deDE } from "@mui/x-data-grid";
import useDateFormatter from "../../hooks/useDateFormatter";

const Index = ({ entries, groupedEntries, roles }) => {
    const [searchTerm, setSearchTerm] = useState("");
    const { formatDate } = useDateFormatter();

    const buttons = [];

    if (roles.includes("Administrator")) {
        buttons.push(
            <InertiaLink key="create" href="/admin/warehouse/create">
                <Button
                    IconComponent={PlusIcon}
                    type="primary"
                >
                    Neuen Eintrag erstellen
                </Button>
            </InertiaLink>
        );
    }

    const filteredResults = groupedEntries.filter(entry => {
        return entry.article_number.includes(searchTerm) || entry.name.toUpperCase().includes(searchTerm.toUpperCase());
    });

    const columns = [
        { field: "id", headerName: "Nummer", width: 100 },
        {
            field: "market.name",
            headerName: "Markt",
            valueGetter: (params) => params.row.market.name,
            width: 200
        },
        {
            field: "article.name",
            headerName: "Artikelbezeichnung",
            valueGetter: (params) => params.row.article.name,
            width: 200
        },
        {
            field: "article.articleNumber",
            headerName: "Artikelnummer",
            valueGetter: (params) => params.row.article.article_number,
            width: 200
        },
    ];

    if (roles.includes("Administrator")) {
        columns.push({
            field: "storage_location.name",
            headerName: "Lagerplatz",
            valueGetter: (params) => params.row.storage_location?.name ?? "-",
            width: 100
        });

        columns.push({
            field: "storage_type",
            headerName: "Lagertyp",
            valueGetter: (params) => {
                const mappings = {
                    "PALLET": "Palette",
                    "PARCEL": "Paket"
                };

                return mappings[params.row.storage_type] ?? "-";
            },
            width: 100
        });
    }

    columns.push(...[
        {
            field: "amount",
            headerName: "Menge",
            width: 100
        },
        {
            field: "created_at",
            headerName: "Eingelagert am",
            type: "date",
            width: 200,
            valueFormatter: (params) => {
                return formatDate(params.value);
            }
        },
        {
            field: "takeout_date",
            headerName: "Ausgelagert am",
            type: "date",
            width: 200,
            valueFormatter: (params) => {
                return formatDate(params.value);
            }
        }
    ]);

    return (
        <Container>
            <PageTitle
                title="Lagerbestand"
                buttons={buttons}
            />

            <div style={{ display: 'flex', height: 700 }} className="bg-white mt-3">
                <div style={{ flexGrow: 1 }}>
                    <DataGrid
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                        onRowClick={(params, event, details) => {
                            window.location.href = `/admin/warehouse/${params.id}`;
                        }}
                        rows={entries}
                        columns={columns}
                    />
                </div>
            </div>

            <h2 className="font-bold text-3xl text-gray-800 leading-tight mt-12">
                Aktueller Warenbestand je Artikel
            </h2>

            <div className="relative mt-2 rounded-md shadow-sm w-2/5">
                <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <SearchIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                </div>
                <input
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    type="text"
                    className="block w-full rounded-md border-0 py-1.5 pl-10 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                    placeholder="Suche nach Artikelnummer oder Artikelbezeichnung..."
                />
            </div>

            <div style={{ display: 'flex', height: 700 }} className="bg-white mt-3">
                <div style={{ flexGrow: 1 }}>
                    <DataGrid
                        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
                        rows={filteredResults}
                        getRowId={row => row.article_number}
                        columns={[
                            {
                                field: "article_number",
                                headerName: "Artikelnummer",
                                width: 200
                            },
                            {
                                field: "name",
                                headerName: "Artikelbezeichnung",
                                valueGetter: (params) => params.row.name,
                                width: 400
                            },
                            {
                                field: "count",
                                headerName: "Menge",
                                width: 100
                            },
                        ]}
                    />
                </div>
            </div>
        </Container>
    );
};

export default Index;
